import { del, get, post, put } from "../helpers/api_helper"

export const inviteUser = data => post(`/notificateInvite/sendEmailToRequester`, data)
export const inviteCompany = data => post(`/notificateInvite/inviteCompany`, data)

export const requestCompanyFromRequester = data => post('/notificateInvite/requestCompanyFromRequester', data)
